import { useNavigate } from "react-router-dom";
import { CalendarPlus, FilePlus2, Mail, Phone, Trash2 } from "lucide-react";
import { waLink } from "@/lib/api";
import { leadWaText } from "@/lib/leads";
import { WhatsAppIcon } from "@/components/site/WhatsAppIcon";

const btn = "h-8 w-8 grid place-items-center rounded-lg transition-colors";

export const ContactButtons = ({ lead, id = lead.id, text = leadWaText(lead) }) => (
  <>
    <a href={waLink(lead.whatsapp || lead.phone, text)} target="_blank" rel="noreferrer" title="WhatsApp" data-testid={`lead-whatsapp-${id}`} className={`${btn} text-emerald-600 hover:bg-emerald-50`}><WhatsAppIcon className="h-4 w-4" /></a>
    <a href={`tel:${lead.phone.replace(/[^\d+]/g, "")}`} title="Call" data-testid={`lead-call-${id}`} className={`${btn} text-navy hover:bg-slate-100`}><Phone className="h-4 w-4" /></a>
    {lead.email ? (
      <a href={`mailto:${lead.email}?subject=${encodeURIComponent("Your Andaman trip - Ocean Wings Travel")}`} title="Email" data-testid={`lead-email-${id}`} className={`${btn} text-ocean hover:bg-sky-50`}><Mail className="h-4 w-4" /></a>
    ) : <span title="No email on file" className={`${btn} text-slate-300`} data-testid={`lead-email-missing-${id}`}><Mail className="h-4 w-4" /></span>}
  </>
);

export const LeadActions = ({ lead, onBook, onDelete }) => {
  const navigate = useNavigate();
  const id = lead.id;
  return (
    <div className="flex items-center gap-0.5">
      <ContactButtons lead={lead} />
      <button type="button" title="Create quotation" onClick={() => navigate(`/admin/quotes/new?enquiry=${id}`)} data-testid={`lead-quote-${id}`} className={`${btn} text-ocean hover:bg-sky-50`}><FilePlus2 className="h-4 w-4" /></button>
      {onBook && <button type="button" title="Convert to booking" onClick={() => onBook(lead)} data-testid={`lead-book-${id}`} className={`${btn} text-ocean hover:bg-sky-50`}><CalendarPlus className="h-4 w-4" /></button>}
      {onDelete && <button type="button" title="Delete lead" onClick={() => onDelete(id)} data-testid={`lead-delete-${id}`} className={`${btn} text-rose-600 hover:bg-rose-50`}><Trash2 className="h-4 w-4" /></button>}
    </div>
  );
};
